import { getLocalStorageItem } from "utils/localStorage";
import { STORAGE_CURRENCY_FROM_LINK } from "constants/variables";
import { createSearchParams, useLocation, useNavigate } from "react-router-dom";
import { GET_PARAMS, GET_POPUP_TYPES } from "constants/popupConfig";
import { useSelector } from "react-redux";
import * as authSelectors from "redux/auth/selectors";
import { useCallback, useEffect } from "react";
import { useCountriesStore } from "stores/countries";
import { useSupport } from "./useSupport";
import { useBreakpoint } from "./useBreakpoint";
import { useGTM } from "./useGTM";

export const useChatwootInit = (): (() => void) => {
  const GTM = useGTM();
  const location = useLocation();
  const navigate = useNavigate();
  const { isDesktop } = useBreakpoint();
  const supportInit = useSupport();

  const isAuthenticated = useSelector(authSelectors.isAuthenticated);
  const countryCode = useCountriesStore((state) => state.countryCode);
  const isCountriesOpen = useCountriesStore((state) => state.isCountriesOpen);
  const setIsCountriesOpen = useCountriesStore(
    (state) => state.setIsCountriesOpen,
  );

  const chatWootInit = useCallback(() => {
    const currencyFromLink = getLocalStorageItem(STORAGE_CURRENCY_FROM_LINK);

    if (!isAuthenticated && !countryCode && !currencyFromLink) {
      if (isDesktop) {
        setIsCountriesOpen(!isCountriesOpen);
      } else {
        navigate({
          pathname: location.pathname,
          search: `?${createSearchParams({ [GET_PARAMS.POPUP]: GET_POPUP_TYPES.popup.countries })}`,
        });
      }
    } else {
      supportInit();
    }

    GTM.clickSupport();
  }, [
    GTM,
    countryCode,
    isAuthenticated,
    isCountriesOpen,
    isDesktop,
    location.pathname,
    navigate,
    setIsCountriesOpen,
    supportInit,
  ]);

  useEffect(() => {
    if (countryCode) {
      setIsCountriesOpen(false);
    }
  }, [countryCode, isCountriesOpen, setIsCountriesOpen]);

  return chatWootInit;
};
